import React from 'react';
import { connect } from 'react-redux';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import style from './awbReturn.module.css';
import commonStyles from '../../common/common.module.css';
import ReturnChargesComponent from './components/ChargesComponent';
import CartItem from '../../../models/CartItem';
import AlternativePaymentOptions from '../../../models/PaymentOptions';
import { Fade, Typography } from '@material-ui/core';
import { History } from 'history';
import PaymentPageContainer from '../../common/paymentPageCommon/PaymentPageContainer';
import { UserRoleType } from '../../../models/User';

const styles = (theme: Theme) =>

  createStyles({
    submitBtn: {
      margin: '10px 20px',
      fontSize: '13px',
    },
    dialogContent: {
      paddingTop: '24px'
    },
    close: {
      fontSize: '27px'
    },
    name: {
      color: 'var(--primaryblue)',
      fontSize: '24px',
    },
    '@media (max-width:480px)': {
      dialogPaper: {
        margin: '0px',
        width: '90%'
      },
    },
  });

interface AwbReturnModalProps {
  classes: any;
  modalOpen: boolean;
  handleCloseModal: (type: string) => void;
  handleChange: (type: string, event: any) => void;
  handleSubmit: () => void;
  handleOpenModal: (type: string) => void;
  cartItem: CartItem | undefined;
  returnCharges: string;
  paymentOptions: AlternativePaymentOptions;
  paymentType: string;
  history: History;
  paymentInfoSelect: string;
  showText: boolean;
  orderNumber?: string;
};

const awbReturnModal = (props: AwbReturnModalProps) => {

  const { classes } = props;
  const titleText: string =  'Capture';
  const typeText: string = 'Return';
  return (
    <Dialog
      open={ props.modalOpen }
      onClose={ () => props.handleCloseModal('missing_payment') }
      fullWidth={true}
      aria-labelledby="form-dialog-title"
      maxWidth={ 'md' }
      disableBackdropClick
      disableEscapeKeyDown
      classes={{ paper: `${props.classes.dialogPaper} ${props.classes.dialogClass}` }}
    >
    <DialogTitle id="form-dialog-title">
      <div className={ style.dialogTitle }>
        <span className={classes.name}>Make Additional Payments</span>
        <IconButton aria-label="Close" onClick={ () => props.handleCloseModal('missing_payment') } className={ classes.close }>
          <CloseIcon color='primary' fontSize='inherit'/>
        </IconButton>
      </div>
      <hr />
    </DialogTitle>
    <DialogContent className={ classes.dialogContent }>
      <div className={ commonStyles.fColumn }>
        <span className={ style.returnCharges }>
          <ReturnChargesComponent
            handleOpenModal={ props.handleOpenModal }
            cartItem={ props.cartItem }
          />
        </span>
        <span className={ style.returnPaymentInfo }>
          <PaymentPageContainer 
            userRole={UserRoleType.FORWARDER }
            history={props.history} 
            orderNumber={ props.orderNumber }
            closeModal={ props.handleCloseModal }
          />
        </span>
      </div>
    </DialogContent>
    <DialogActions>
      <Fade in={props.showText} timeout={ 1000 }>
        <Typography variant="subtitle1" gutterBottom style={ { color: 'green' } }>
          Return Order Created
        </Typography>
      </Fade>
    </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles)(connect(null, {})(awbReturnModal));
